<template>
  <div class="index-header">
    <a href="/">
      <img :src="staticUrl+'office/xzdzm/m/game-icon.png'" class="header_icon" />
    </a>
    <a href="/">
      <img :src="staticUrl+'office/xzdzm/m/game-name.png'" class="header_name" />
    </a>
    <div class="menu-but" @click="isShowMenu"></div>
    <div class="menu-cover" v-if="isShow">
      <div class="menu-cover-mask" @click="isHiddenMenu"></div>
      <div class="menu-cover-wrap">
        <div class="close-btn" @click="isHiddenMenu"></div>
        <div class="menu-items">
          <div class="menu_item" :class="{ active: 'center_top'=== currentActive }" @click="activeClass('center_top')">首页</div>
          <div class="menu-line"></div>
          <div class="menu_item" :class="{ active: 'center_zmkb'=== currentActive }" @click="activeClass('center_zmkb')">宗门快报</div>
          <div class="menu-line"></div>
          <div class="menu_item" :class="{ active: 'center_dztj'=== currentActive }" @click="activeClass('center_dztj')">弟子图鉴</div>
          <div class="menu-line"></div>
          <div class="menu_item" :class="{ active: 'center_tese'=== currentActive }" @click="activeClass('center_tese')">仙门特色</div>
        </div>
        <div class="menu-share">
          <div class="share-item" @click="createSuperLabel('qq', downloadUrl.qqUrl)">
            <img :src="staticUrl+'office/xzdzm/m/share-qq.png'"/>
          </div>
          <div class="share-item" @click="wxToLink">
            <img :src="staticUrl+'office/xzdzm/m/share-wechat.png'"/>
          </div>
          <div class="share-item" @click="createSuperLabel('sina', downloadUrl.sinaUrl)">
            <img :src="staticUrl+'office/xzdzm/m/share-weibo.png'"/>
          </div>
          <div class="share-item">
            <a href="mailto:xzdzm_cs@zhuziplay.com?subject=contact">
              <img :src="staticUrl+'office/xzdzm/m/share-mail.png'"/>
            </a>
          </div>
          <div class="share-item" @click="createSuperLabel('taptap', downloadUrl.taptapUrl)">
            <img :src="staticUrl+'office/xzdzm/m/share-tap.png'"/>
          </div>
          <div class="share-item" @click="createSuperLabel('bao', downloadUrl.haoyouUrl)">
            <img :src="staticUrl+'office/xzdzm/m/share-bao.png'"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'headerBar',
  data () {
    return {
      currentActive: 'center_top',
      isShow: false
    }
  },
  computed: {
    ...mapGetters([
      'staticUrl',
      'isMobile',
      'downloadUrl'
    ])
  },
  created () {},
  methods: {
    goBack () {
      this.$router.back(-1)
    },
    activeClass (index) {
      this.currentActive = index
      document.querySelector('#' + index).scrollIntoView(
        { behavior: 'smooth' }
      )
    },
    isShowMenu () {
      this.isShow = true
    },
    isHiddenMenu () {
      this.isShow = false
    },
    wxToLink () {
      this.isShow = false
      this.isShowWxLink = true
    },
    createSuperLabel (id, url) {
      let a = document.createElement('a');
      a.setAttribute('href', url);
      a.setAttribute('target', '_blank');
      a.setAttribute('id', id);
      if (!document.getElementById(id)) {
        document.body.appendChild(a);
      }
      a.click();
    },
  }
}
</script>

<style lang="scss">

</style>
